module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dayWrapper"
  }, [_c('header', {
    staticClass: "flexRow"
  }, [_c('h1', [_vm._v("Today")]), _vm._v(" "), _c('new-category', {
    staticClass: "newCategoryButton"
  }), _vm._v(" "), (_vm.isBetaUser && _vm.isMobile()) ? _c('the-line', {
    attrs: {
      "categories": _vm.categories
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.orderedCategories), function(category) {
    return (!category.parentId) ? [_c('div', {
      class: ['flexRow category', category.children && category.showChildren ? 'parent' : ''],
      on: {
        "click": function($event) {
          return _vm.emitCategoryClick(category.id)
        }
      }
    }, [_c('category-details-block', {
      attrs: {
        "category": category,
        "completed": _vm.getCategoryCompleted(category.id, _vm.date),
        "quota": _vm.getCategoryQuota(category.id),
        "directLink": false,
        "showEditTrigger": true
      }
    }), _vm._v(" "), _c('current-blocks', {
      staticClass: "currentBlocks",
      attrs: {
        "blocks": !category.showChildren ? category.totalBlocks : category.blocks,
        "category": category.name,
        "quota": _vm.getCategoryQuota(category.id, _vm.date, false),
        "color": category.color,
        "categoryId": category.id,
        "isContinuous": true,
        "customDate": _vm.date
      }
    })], 1), _vm._v(" "), (category.showChildren) ? _vm._l((Object.keys(category.children || {})), function(childId) {
      return _c('div', {
        staticClass: "flexRow subcategory",
        on: {
          "click": function($event) {
            return _vm.emitCategoryClick(childId)
          }
        }
      }, [_c('subcategory-details-block', {
        attrs: {
          "categoryId": childId,
          "showEditTrigger": true
        }
      }), _vm._v(" "), _c('current-blocks', {
        staticClass: "currentBlocks",
        attrs: {
          "blocks": _vm.categories[childId].blocks,
          "category": _vm.categories[childId].name,
          "quota": _vm.getCategoryQuota(childId, _vm.date, false),
          "color": _vm.categories[childId].color,
          "categoryId": childId,
          "isContinuous": true,
          "customDate": _vm.date
        }
      })], 1)
    }) : _vm._e()] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b36cae8!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/TodayView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-8b36cae8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/TodayView.vue
// module chunks = 0